export const SETTINGS_PARAM = 'config';

export const SETTINGS_SECTIONS = [
  { key: 'ratings', labelKey: 'policies.tab.ratings' },
  { key: 'liquidez', labelKey: 'policies.tab.liquidity' },
  { key: 'empresas', labelKey: 'policies.tab.companies' },
] as const;

export type SettingsSection = (typeof SETTINGS_SECTIONS)[number]['key'];

export const DEFAULT_SETTINGS_SECTION: SettingsSection = 'ratings';

export const isSettingsSection = (value: string | null | undefined): value is SettingsSection =>
  SETTINGS_SECTIONS.some(({ key }) => key === value);
